import Vue from 'vue';

export default {
  SET_INITIALIZED(state){
    state.initialized = true;
  },

  SET_NOTIFICATIONS(state, notifications){
    state.notifications = notifications;
  },

  UPDATE_NOTIFICATION(state, {notificationId, changes}){
    let notifications = state.notifications || [];
    state.notifications = notifications.map(notification => {
      if(notification._id === notificationId)
        return {...notification, ...changes};

      return notification;
    });
  },

  FETCHING_NOTIFICATIONS(state, status){
    state.fetchingNotifications = status;
  },

  SET_AUTH_USER(state, user){
    state.authUser = user
  },

  SET_NOT_ALLOWED_MESSAGE(state, message){
    state.notAllowedMessage = message;
  },

  SET_DASHBOARD_DATA(state, dashboardData){
    state.dashboardData = dashboardData;
  },

  FETCHING_DASHBOARD_DATA(state, status){
    state.fetchingDashboardData = status;
  },
  
  SET_DASHBOARD_LOANS(state, dashboardLoans){
    state.dashboardLoans = dashboardLoans;
  },

  FETCHING_DASHBOARD_LOANS(state, status){
    state.fetchingDashboardLoans = status;
  },

  SET_FETCHING_USERS(state, status){
    state.fetchingUsers = status;
  },

  SET_USERS(state, users){
    state.users = users
  },

  UPDATE_USER(state, payload){
    const { index, field } = payload;
    Vue.set(state.users[index], field, payload[field])
  },

  SET_SELECTED_USER(state, user){
    state.selectedUser = user
  },

  UPDATE_SELECTED_USER(state, payload){
    const { field } = payload;
    Vue.set(state.selectedUser, field, payload[field])
  },

  SET_DASHBOARD_SUMMARIES(state, {index, value}){
    Vue.set(state.dashboardSummaries, index, value);
  },

  SET_SAVINGS_DATA(state, {data, pagination}){
    state.savingsData = data;
    state.savingsPagination = pagination;
  },

  FETCHING_SAVINGS_DATA(state, status){
    state.fetchingSavingsData = status;
  },

  SET_STAFF_USERS(state, staffUsers){
    state.staffUsers = staffUsers;
  },

  FETCHING_STAFF_USERS(state, status){
    state.fetchingStaffUsers = status;
  },

  CREATING_STAFF_USER(state, status){
    state.creatingStaffUser = status;
  },

  SET_STAFF_USER_BEING_EDITED(state, staffUserBeingEdited){
    state.staffUserBeingEdited = staffUserBeingEdited;
  },

  SET_ROLES(state, roles){
    state.roles = roles;
  },

  FETCHING_ROLES(state, status){
    state.fetchingRoles = status;
  },

  CREATING_ROLE(state, status){
    state.creatingRole = status;
  },

  SET_ROLE_BEING_EDITED(state, role){
    state.roleBeingEdited = role;
  },

  DELETING_ROLE(state, status){
    state.deletingRole = status;
  },

  SET_ROLE_BEING_DELETED(state, role){
    state.roleBeingDeleted = role;
  },

  FETCHING_ROLE_STAFF_USERS(state, status){
    state.fetchingStaffUsersForRole = status;
  },

  SET_PERMISSIONS(state, permissions){
    state.permissions = permissions;
  },

  FETCHING_PERMISSIONS(state, status){
    state.fetchingPermissions = status;
  },

  SET_BANK_BALANCES(state, {data, pagination}){
    state.bankBalances = data;
    if(pagination)
      state.bankBalancesPagination = pagination;
  },

  FETCHING_BANK_BALANCES(state, status){
    state.fetchingBankBalances = status;
  },

  CREATING_BANK_BALANCE(state, status){
    state.creatingBankBalance = status;
  },

  UPDATE_BANK_BALANCE(state, {bankBalanceId, changes}){
    let bankBalances = state.bankBalances || [];
    state.bankBalances = bankBalances.map(bankBalance => {
      if(bankBalance._id === bankBalanceId)
        return {...bankBalance, ...changes};

      return bankBalance;
    });
  },

  FETCHING_RECON_STATEMENT(state, status){
    state.fetchingReconStatement = status;
  },

  SET_RECON_STATEMENT(state, reconStatement){
    state.reconStatement = reconStatement;
  },
  
  FETCHING_FINLINK_ACCOUNTS(state, status){
    state.fetchingFinlinkAccounts = status;
  },

  SET_FINLINK_ACCOUNTS(state, finlinkAccounts){
    state.finlinkAccounts = finlinkAccounts;
  },
  
  SET_SELECTED_FINLINK_ACCOUNT(state, accountId){
    state.selectedFinlinkAccountId = accountId;
  },

  FETCHING_FINLINK_ACCOUNT_TRANSACTIONS(state, status){
    state.fetchingFinlinkAccountTransactions = status;
  },

  SET_FINLINK_ACCOUNT_TRANSACTIONS(state, {data, pagination}){
    state.finlinkAccountTransactions = data;
    if(pagination)
      state.finlinkAccountTransactionsPagination = pagination;
  },

  SET_TRANSACTION_LOGS(state, {data, pagination}){
    state.transactionLogs = data;
    if(pagination)
      state.transactionLogsPagination = pagination;
  },

  FETCHING_TRANSACTION_LOGS(state, status){
    state.fetchingTransactionLogs = status;
  },
  
  SET_TRANSACTIONS(state, {data, pagination}){
    state.transactions = data;
    if(pagination)
      state.transactionsPagination = pagination;
  },

  SET_TRANSACTION_TYPE_FILTER(state, filter){
    state.transactionTypeFilter = filter;
  },

  FETCHING_TRANSACTIONS(state, status){
    state.fetchingTransactions = status;
  },

  CREATING_TRANSACTION(state, status){
    state.creatingTransaction = status;
  },

  UPDATE_TRANSACTION(state, {transactionId, changes}){
    let transactions = state.transactions || [];
    state.transactions = transactions.map(transaction => {
      if(transaction._id === transactionId)
        return {...transaction, ...changes};

      return transaction;
    });
  },

  SET_BANK_TRANSACTIONS(state, bankTransactions){
    state.bankTransactions = bankTransactions;
  },

  FETCHING_BANK_TRANSACTIONS(state, status){
    state.fetchingBankTransactions = status;
  },

  CREATING_BANK_TRANSACTION(state, status){
    state.creatingBankTransaction = status;
  },

  UPDATE_BANK_TRANSACTION(state, {bankTransactionId, changes}){
    let bankTransactions = state.bankTransactions || [];
    state.bankTransactions = bankTransactions.map(bankTransaction => {
      if(bankTransaction._id === bankTransactionId)
        return {...bankTransaction, ...changes};

      return bankTransaction;
    });
  },

  SET_ACCOUNTS(state, accounts){
    state.accounts = accounts;
  },

  FETCHING_ACCOUNTS(state, status){
    state.fetchingAccounts = status;
  },

  SET_AUDIT_TRAIL(state, {data, metadata}){
    state.auditTrail = data;
    state.auditTrailMetadata = metadata;
  },

  FETCHING_AUDIT_TRAIL(state, status){
    state.fetchingAuditTrail = status;
  },
  
  FETCHING_CONFIGS(state, status){
    state.fetchingConfigs = status;
  },

  SET_CONFIGS(state, configs){
    state.configs = configs;
  },

  SET_CONFIG_BEING_EDITED(state, config){
    state.configBeingEdited = config;
  },
  
  SAVING_CONFIG(state, status){
    state.savingConfig = status;
  },
  
  FETCHING_SUPPORTED_BANKS(state, status){
    state.fetchingSupportedBanks = status;
  },

  SET_SUPPORTED_BANKS(state, {data, pagination}){
    state.supportedBanks = data;
    if(pagination)
      state.supportedBanksPagination = pagination;
  },

  SET_SUPPORTED_BANK_BEING_EDITED(state, supportedBank){
    state.supportedBankBeingEdited = supportedBank;
  },
  
  SAVING_SUPPORTED_BANK(state, status){
    state.savingSupportedBank = status;
  },
  
  FETCHING_LOAN_APPLICATIONS(state, status){
    state.fetchingLoanApplications = status;
  },

  SET_LOAN_APPLICATIONS(state, {data, pagination}){
    state.loanApplications = data;
    if(pagination)
      state.loanApplicationsPagination = pagination;
  },

  SET_LOAN_APPLICATION_BEING_EDITED(state, loanApplication){
    state.loanApplicationBeingEdited = loanApplication;
  },
  
  SAVING_LOAN_APPLICATION(state, status){
    state.savingLoanApplication = status;
  },

  SET_REMINDERS(state, reminders){
    state.reminders = reminders;
  },

  FETCHING_REMINDERS(state, status){
    state.fetchingReminders = status;
  },

  CREATING_REMINDER(state, status){
    state.creatingReminder = status;
  },
  
  SET_REMINDER_BEING_EDITED(state, reminderId){
    state.reminderBeingEditedId = reminderId;
  },
}
